
<fieldset>
    <legend id="step1">
        {{ step2.getobjet | translate }}
    </legend>

    <app-form-input [parentForm]="parentForm" [value]="description.objet"  [label]="step2.getobjet" [disabled]="disabled"
        [type]="'text'" [rule]="'required|minSize_5'" [errorMessage]="{'required' : 'ctr_107', 'minLength' : 'ctr_123'}" [name]="getUid()+'_SepAtt_objet'">
    </app-form-input>

    <app-type-objCPV [uid]="getUid()" [parentForm]="parentForm" [cpv]="description.cpv" [disabled]="disabled"></app-type-objCPV>
</fieldset>


<app-form-input
    [parentForm]="parentForm"
    [disabled]="disabled"
    [value]="description.isLieuExecutionLivraison"

    [label]="step2.getlieuexecutionlivraison"
    [type]="'checkbox'"
    [rule]="'pattern_29'"
    [name]="getUid() + '_SepAtt_lieuExecutionLivraisonCB'"
    [checkboxDestination]="'boolean'"
>
</app-form-input>

<div *ngIf="estCbChecked">
    <fieldset>
        <legend id="step1">
            {{ step2.getspan4 | translate }}
        </legend>
        <app-type-lieu [uid]="getUid()+'_lieuExecutionLivraison'" [parentForm]="parentForm"
            [disabled]="disabled"
            [rule]="'required'"
            [errorMessage]="{'pattern' : 'ctr_221'}"
            [lieuExecutionLivraison]="description.lieuExecutionLivraison">
        </app-type-lieu>
        <app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg2" [id]="getStepId() + rg2"></app-form-input-error>
    </fieldset>
</div>

<div *ngIf="!estCbChecked">
    <fieldset>
        <legend id="step1">
            {{ step2.getspan4 | translate }}
        </legend>
        <app-type-lieu [uid]="getUid()+'_lieuExecution'" [parentForm]="parentForm"
            [disabled]="disabled"
            [rule]="'required'" [errorMessage]="{'pattern' : 'ctr_221'}"
            [lieuExecutionLivraison]="description.lieuExecution">
        </app-type-lieu>
        <app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg3" [id]="getStepId() + rg3"></app-form-input-error>
    </fieldset>

    <fieldset>
        <legend id="step1">
            {{ step2.getspan5 | translate }}
        </legend>
        <app-type-lieu [uid]="getUid()+'_lieuLivraison'" [parentForm]="parentForm"
            [disabled]="disabled"
            [rule]="'required'" [errorMessage]="{'pattern' : 'ctr_222'}"
            [lieuExecutionLivraison]="description.lieuLivraison">
        </app-type-lieu>
        <app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg4" [id]="getStepId() + rg4"></app-form-input-error>
    </fieldset>
</div>

<!-- a verifier si on doit le mettre ou non
    <app-type-lieu [uid]="getUid()+'_lieuLivraison'" [parentForm]="parentForm"
    [lieuExecutionLivraison]="description.lieuExecutionLivraison"></app-type-lieu> -->
